<div class="dialog-wrapper" style="padding: 16px;">
  <div class="dialog-header">
    <span class="dialog-heading">{{
      isEdit ? ("editFolderName" | translate) : ("createFolder" | translate)
    }}</span>
    <mat-icon style="margin-bottom: 12px;" class="h-24-w-24 cursor-pointer" (click)="closeDialog()"
      >close</mat-icon
    >
  </div>
  <form #form="ngForm" (submit)="form.valid && submitFolderAction()">
    <mat-form-field [hideRequiredMarker]="true"
      appearance="outline"
      [ngClass]="{ 'mat-form-field-invalid': folderAlreadyExists }"
    >
      <mat-label>{{ "folderForm.folderName" | translate }}</mat-label>
      <input
        required
        matInput
        [(ngModel)]="folderName"
        name="folderName"
        (ngModelChange)="folderAlreadyExists = false"
        #folderInput="ngModel"
         [autofocus]="false"
      />
      <mat-hint
        *ngIf="folderAlreadyExists"
        class="red-hint" style="position: relative;top: 15px"
      >
        Folder name already exists 1
      </mat-hint>
    </mat-form-field>
    <!-- <span *ngIf="folderAlreadyExists">
      Postoji već folder sa istim imenom.
    </span> -->
    <div class="button-wrapper">
      <button
        class="create-folder-button cursor-pointer primary-button custom-button"
        [promiseBtn]="creating"
        [class.disabled-button]="!form.valid || !folderName.trim()"
        [disabled]="!form.valid"
        type="submit"
      >
        <span>{{
          isEdit ? ("editFolder" | translate) : ("createFolderTwo" | translate)
        }}</span>
      </button>
    </div>
  </form>
</div>
